// extracted by mini-css-extract-plugin
export default {"leaveGroupModal__overlay":"LeaveGroupModal_leaveGroupModal__overlay__swopl","modal":"LeaveGroupModal_modal__lnw66","modal__btns":"LeaveGroupModal_modal__btns__mth7o"};